// ./src/utils/api/commentAuthorPicture.ts
//
// A2e #91 — the picture to draw for a comment's author: the stored photo (a guest's, as the event site shows them), else
// a ready URL (a guest's Gravatar, a host's account picture), else null — draw their initials. Pure, so
// `check-answer-image` runs it.

export interface CommentAuthorPictureFields {
  commenterPhoto?: { fileUrl?: string | null; thumbnailUrl?: string | null } | null;
  commenterAvatarUrl?: string | null;
}

export const commentAuthorPicture = (c: CommentAuthorPictureFields): string | null =>
  c.commenterPhoto?.thumbnailUrl || c.commenterPhoto?.fileUrl || c.commenterAvatarUrl || null;
